<template>
    <div fluid class="pa-0 ma-0">

        <div class="background">

            <div class="d-flex justify-center pa-5" style="margin-top: 200px;">
                <div class="pt-4 mr-4">
                    <v-img src="~@/assets/simplelogo.png" contain width="64"/>
                </div>
                <div class="white--text" style="font-size: 64px;">Simple Pricing</div>
            </div>

            <div class="text-center">
                <v-btn
                    large
                    rounded
                    color="orange"
                    class="white--text"
                    href="https://meetabout.it/app/index.html"
                >
                    <span class="mr-2">Get Started for Free</span>
                </v-btn>
            </div>

            <v-container>
                <v-row>
                    <v-col :cols="smallScreen ? 12 : 4" v-for="(card,i) in cards" :key="`card-`+i">
                        <v-card class="ma-4 pa-5">
                            <v-card-title>
                                <div class="text-center text-h5" style="width: 100%;">
                                    {{card.title}}
                                </div>
                                
                            </v-card-title>
                            <v-card-text class="mb-10" style="height: 400px;">
                                <div class="subtitle-2 text-center green--text">{{card.pricing}}</div>
                                <div v-for="(o, j) in card.opts" :key="`opt-`+j">
                                    <div class="d-flex mt-5">
                                        <v-icon color="orange">fat fa-check-circle</v-icon>
                                        <div class="ml-5 subtitle">{{o}}</div>
                                    </div>
                                    
                                </div>
                            </v-card-text>

                            <v-card-actions class="justify-center px-10">
                                <v-btn 
                                    href="https://meetabout.it/app/index.html"
                                    block elevation="0" rounded large 
                                    color="orange" dark
                                >Get Started</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Home',
    computed:{
        smallScreen() {
            return this.$vuetify.breakpoint.smAndDown ? true : false
        },
        mediumScreen() {
            return this.$vuetify.breakpoint.mdAndDown ? true : false
        }
    },
    data: () => ({
        cards: [{
            title: 'Startup',
            pricing: '$0',
            opts: [
                'Up to 10 users',
                'Unlimited tasks, notes and agendas',
                'Reporting/Dashboard for the last 30 days',
                'Google and Slack Integrations',
                'Email Chat Support',
                'Effectiveness Surveys'
            ]
        }, {
            title: 'Scaling',
            pricing: '$4.99/Person Monthly',
            opts: [
                'Up to 100 users',
                'Unlimited tasks, notes and agendas',
                'Full Historical Reporting/Dashboard',
                'Google and Slack Integrations',
                'Chrome Extension Quick Add',
                'Email Chat Support',
                'Weekly User Reports',
                'Customizable Surveys'
            ]
        }, {
            title: 'We Made It',
            pricing: 'Contact Us',
            opts: [
                '101+ users'
            ]
        }]
    })
  }
</script>

<style lang="scss" scoped>
.background {
    position: absolute;
    width: 100%;
    top: 0;
    height: 100%;
    overflow: hidden;
    background-image: url(~@/assets/teamBackground.jpeg);
    background-repeat: no-repeat;
    background-size: cover;
    overflow: scroll;
}

.product-summary {
    margin-top: 200px;
    margin-bottom: 200px;
    background: white;
    padding: 80px 40px 100px 40px;
}
</style>
